import React from 'react';
import { DataSiteEmailTrackingData } from '$/core/models';

interface TaskCellRendererProps {
  value?: string;
  data?: DataSiteEmailTrackingData;
  onCreateTask?: (taskData: DataSiteEmailTrackingData) => void;
}

const TaskCellRenderer: React.FC<TaskCellRendererProps> = ({ value, data, onCreateTask }) => {
  if (value) {
    return (
      <div className="workflow-management-task-assignee">
        <span className="workflow-management-task-assignee-label">Assignee:</span>
        <span className="workflow-management-task-assignee-name">{value}</span>
      </div>
    );
  }

  const handleClick = () => {
    if (data && onCreateTask) {
      onCreateTask(data);
    }
  };

  return (
    <button className="workflow-management-create-task-button" onClick={handleClick}>
      Create Task
    </button>
  );
};

export default TaskCellRenderer;
